import React, { FC, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { getUserSession } from "../../Common/lib/Session";

const Authorized: FC<{ children: React.ReactNode }> = ({ children }) => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    getUserSession().then((result) => {
      if (!result.success) {
        history.replace(`/signin?return=${escape(location.pathname)}`);
      } else if (!result.is_staff && !result.contributor_access) {
        alert("Sorry, your account is not eligible to submit datasets.");
        history.replace("/");
      }
    });
  }, [history, location]);

  return children as React.ReactElement;
};

export default Authorized;
